import { motion } from "framer-motion";
import { Check, Plus } from "lucide-react";
import { waLink } from "@/data/site";
import { SERVICE } from "@/constants/testIds";

const PackagesGrid = ({ packages = [], dark = false, serviceName = "" }) => {
  if (!packages.length) return null;
  const cols = packages.length >= 4 ? "lg:grid-cols-4" : packages.length === 3 ? "lg:grid-cols-3" : "lg:grid-cols-2";

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 ${cols} gap-6 md:gap-8`}>
      {packages.map((p, i) => (
        <motion.article
          key={p.name}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: i * 0.06 }}
          className={`relative p-8 md:p-10 flex flex-col ${
            dark
              ? p.featured
                ? "bg-white text-ink border-2 border-gold"
                : "bg-white/5 border border-white/10 text-white"
              : p.featured
                ? "bg-ink text-white"
                : "bg-white border border-neutral-200 text-ink"
          }`}
        >
          {(p.featured || p.badge) && (
            <span className="absolute -top-3 left-8 text-[10px] uppercase tracking-[0.3em] text-white bg-gold px-3 py-1">
              {p.badge || "Meest gekozen"}
            </span>
          )}
          <h3 className="font-serif text-3xl">{p.name}</h3>
          {p.tag && (
            <span className="text-[10px] uppercase tracking-[0.3em] text-gold mt-1">{p.tag}</span>
          )}
          <p className="font-serif text-4xl text-gold mt-4">{p.price}</p>
          <div className="flex-1">
            <ul className={`mt-8 space-y-3 text-sm ${
              p.featured
                ? dark ? "text-neutral-700" : "text-white/85"
                : dark ? "text-white/75" : "text-neutral-700"
            }`}>
              {p.features.map((f) => (
                <li key={f} className="flex items-start gap-2">
                  <Check size={14} className="text-gold mt-1 shrink-0" />
                  <span>{f}</span>
                </li>
              ))}
            </ul>
            {p.extras && p.extras.length > 0 && (
              <div className={`mt-6 p-4 rounded-sm border border-gold/50 ${
                p.featured ? (dark ? "bg-gold/5" : "bg-gold/10") : (dark ? "bg-gold/10" : "bg-gold/5")
              }`}>
                <p className="text-[10px] uppercase tracking-[0.3em] text-gold mb-3 font-semibold">Extra&apos;s (optioneel)</p>
                <ul className={`space-y-2 text-sm font-medium ${
                  dark ? "text-white/90" : "text-neutral-800"
                }`}>
                  {p.extras.map((e) => (
                    <li key={e} className="flex items-start gap-2">
                      <Plus size={15} strokeWidth={2.5} className="text-gold mt-0.5 shrink-0" />
                      <span>{e}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <a
            data-testid={`${SERVICE.bookBtn}-${(serviceName || "").toLowerCase()}-${i}`}
            href={waLink(`Hallo Eric, ik wil graag info over het ${p.name}-pakket${serviceName ? ` (${serviceName})` : ""}.`)}
            target="_blank"
            rel="noreferrer"
            className={`mt-8 block text-center py-3 text-[10px] uppercase tracking-[0.3em] transition-colors ${
              p.featured
                ? "bg-gold text-white hover:bg-gold-dark"
                : dark
                  ? "border border-white/40 text-white hover:border-gold hover:text-gold"
                  : "border border-ink text-ink hover:bg-ink hover:text-white"
            }`}
          >
            Reserveer
          </a>
        </motion.article>
      ))}
    </div>
  );
};

export default PackagesGrid;
